<div class="container-fluid" style="padding-right: 10px;">
<div  style="display: inline;block-size: 10%;">

  <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 20px 0px 15px 5px;">

    <!-- <div class="col-md-4 col-sm-6" style="display: inline-block;padding: 0px;">

      <h2 class="ng-binding header">
        Transaction History
      </h2>
    </div> -->
    
    <div class="col-md-4 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
        <h2 style="font-size: 25px; margin-bottom: 0px;"> {{headerName}} </h2>
    </div>

    <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
      <span class="search">
        <span class="fa fa-search"></span>
        <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
          (keyup)="applyFilter($event)" #input
          style="text-align: left; background-color: white !important;  display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 30% !important; height: 31px !important;"
          type="text">
      </span>
      <!-- 
      <span class="btn btn-green" style="cursor: pointer;line-height: 22px; padding: 5px 11px;" title="Refresh">
        <span>
          <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
        </span>
      </span> -->

      <span (click)="exportToExcelActivities()" class="orangeButton"
        style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
        <span>
          <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
        </span>
      </span>

      <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
        <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
          (click)="backBtn()">
          <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
        </span>
      </div>

    </div>
  </div>
</div>

<div style="display: flex; gap: 10px; flex-wrap: wrap; padding: 0px 0px 10px 5px;">
  <div style="display:inline-block;">
    <!-- <div style="display: inline-block;">
      <label style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
        for="sel1">Month : </label>
    </div> -->

    <div style="display: inline-block;">
      <select  class="form-control bgwhite formCtlFltr " style="box-shadow: none;width: 100px;cursor: pointer;" [(ngModel)]="monthDisplay"
        (change) ="trasYearChange()">
        <option *ngFor="let i of months;">{{i.display}}</option>
      </select>
    </div>
  <!-- 
    <div style="display: inline-block; margin-left: 0px; margin-right: 10px;">
      <select class="form-control bgwhite bdrrd5" style="box-shadow: none; cursor: pointer;" [(ngModel)]="monthDisplay"
          (change)="trasYearChange()">
          <option *ngFor="let i of months;">{{i.display}}</option>
      </select>
  </div> -->
  </div>

  <div style="cursor: pointer; display: flex; align-items: center; justify-content: center; height: 30px; flex: 0 0 auto;" (click)="showDateRangePicker()">
      <span style="font-size: 17px; color: #15304a;"><i class="fa fa-calendar"></i></span>
  </div>

  <div *ngIf="showDatePicker">
    <span style="font-size: 13px !important; color: #daa520 !important;">
        <input [min]="minDate" [max]="maxDate" matInput [matDatepicker]="picker" [ngModel]="startDate" (click)="picker.open()"
            class="formCtlFltr  form-control bgwhite" (ngModelChange)="startDateChange($event)"
            style="color:#555 !important; display: inline-block; width: 80px; background: #FFF; cursor: pointer; font-size: 12px;text-indent: 5px;vertical-align: middle;">
        <!-- <mat-datepicker-toggle matSuffix [for]="picker" style="vertical-align: middle; color: #daa520 !important"></mat-datepicker-toggle> -->
        <mat-datepicker #picker></mat-datepicker>
    </span>

    <span style="font-size: 13px; margin-left: 10px;">to</span>
    <span class="dtpicker" style="margin-right: 5px;margin-left: 10px;font-size: 12px !important; color: #daa520 !important;">
        <input [min]="toMinDate" [max]="toMaxDate" matInput [matDatepicker]="toPicker" [ngModel]="endDate" (click)="toPicker.open()"
            class="formCtlFltr  form-control bgwhite" (ngModelChange)="endDateChange($event)"
            style="color:#555 !important;display: inline-block; width: 80px; background: #FFF; cursor: pointer;font-size: 13px;text-indent: 5px;vertical-align: middle;">
        <!-- <mat-datepicker-toggle matSuffix [for]="Newdate" style="vertical-align: middle; color:#daa520 !important"></mat-datepicker-toggle>   -->
        <mat-datepicker #toPicker></mat-datepicker>
    </span>
  </div>

  <div style="display:inline-block;">
    <!-- <div style="display: inline-block;">
      <span style="color: #15304a; margin-right: 8px"><i class="zmdi zmdi-store"></i></span>
    </div> -->
    <div style="display: inline-block;">
      <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 130px; cursor: pointer;" [(ngModel)]="store.id" (change)="ChangeStore()">
        <option value="0">All Stores</option>
        <option *ngFor="let s of storeList" value="{{s.StrID}}">{{s.sNm}}</option>
      </select>
    </div>
  </div>

  <div style="display:inline-block">
    <!-- <div style="display: inline-block;">
      <span style="color: #15304a; margin-right: 8px"><i class="zmdi zmdi-account"></i></span>
    </div> -->
    <div style="display: inline-block;">
      <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 134px; cursor: pointer;" [(ngModel)]="user.id" (change)="chnageUser()">
        <option value="0">All Executives</option>
        <option *ngFor="let s of userList" value="{{s.UserID}}">{{s.Name}}</option>
      </select>
    </div>
  </div>
</div>


<!-- <div class="col-md-3 col-sm-3 col-xs-12" style="display:inline-block" *ngIf="transType.id == 0">
  <div style="display: inline-block;">
    <span style="color: #E1A730; margin-right: 8px"><i class="zmdi zmdi-widgets"></i></span>
  </div>
  <div style="display: inline-block;margin-left: 10px;" >
    <select class="form-control bgwhite bdrrd5" style="box-shadow: none;" [(ngModel)]="transType.id">
      <option value="0">All</option>
      <option *ngFor="let s of transactionType" value="{{s.id}}">{{s.type}}</option>
    </select>
  </div>
</div> -->

<!-- <div class="col-md-2 col-xs-12 col-sm-2" style="display:inline-block">

  <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
    <span class="btn-orange" style="font-size: 12px; display: inline-block; padding: 4px 11px 4px; margin-left: 10px;"
      (click)="Search()">
      <i class="fa fa-search" style="margin-right: 3px;"></i> Search
    </span>
  </div>
</div> -->
<div class="wrapper" style="text-overflow: ellipsis; white-space: nowrap;margin: 15px 0px 15px 5px;"
  *ngIf="dataSource.data.length > 0" #trasrptable>
  <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow" style="width: 99%;">
  <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
   
    <ng-container matColumnDef="Date" style="cursor: pointer;">

      <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Date</label>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.Date}} </td>
    </ng-container>

    <ng-container matColumnDef="XnNo">
      <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Xn No.</label>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.XnNo}} </td>
    </ng-container>

    <ng-container matColumnDef="storeName">
      <th [style.display]="(currXnTypeID == 8) ? ' ' : 'none'" class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Store</label>
      </th>
      <td [style.display]="(currXnTypeID == 8) ? ' ' : 'none'" mat-cell *matCellDef="let element">{{element.storeName}}</td>
    </ng-container>
  
    <ng-container matColumnDef="outStoreName">
      <th [style.display]="[9,4,5,12,13].includes(currXnTypeID) ? ' ' : 'none'" class="header header-Table"
       style="cursor: pointer; border-radius: 0px; margin: 0px !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>{{[9,12,13].includes(currXnTypeID) ? 'Out Store' : 'Store'}}</label>
      </th>
      <td [style.display]="[9,4,5,12,13].includes(currXnTypeID) ? ' ' : 'none'" mat-cell *matCellDef="let element">
        {{element.outStoreName}} 
      </td>
    </ng-container>

    <ng-container matColumnDef="inStoreName">
      <th [style.display]="[7,1,2,9,12,13].includes(currXnTypeID) ? ' ' : 'none'" class="header header-Table"
       style="cursor: pointer; border-radius: 0px; margin: 0px !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>{{[9,12,13].includes(currXnTypeID) ? 'In Store' : 'Store'}}</label>
      </th>
      <td [style.display]="[7,1,2,9,12,13].includes(currXnTypeID) ? ' ' : 'none'" mat-cell *matCellDef="let element">
          {{element.inStoreName}} 
      </td>
    </ng-container>

    <ng-container matColumnDef="XnByUserName">
      <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label> By </label>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.XnByUserName}} </td>
    </ng-container>

    <!-- <ng-container matColumnDef="toUserName">
      <th [style.display]="(currXnTypeID == 7) ? ' ' : 'none'" class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label> To </label>
      </th>
      <td [style.display]="(currXnTypeID == 7) ? ' ' : 'none'" mat-cell *matCellDef="let element">{{element.toUserName}} </td>
    </ng-container> -->

    <ng-container matColumnDef="NewinStoreName">
      <th [style.display]="(currXnTypeID == 8) ? ' ' : 'none'"  class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Type</label>
      </th>
      <td [style.display]="(currXnTypeID == 8) ? ' ' : 'none'" mat-cell *matCellDef="let element">{{element.NewinStoreName ? 'In' : 'Out'}}</td>
    </ng-container>

    <ng-container matColumnDef="Notes">
      <th [style.display]="(currXnTypeID == 5 || currXnTypeID == 2 || currXnTypeID == 9 || currXnTypeID == 7 || currXnTypeID == 8) ? ' ' : 'none'" class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label style="cursor: pointer">Notes</label>
      </th>
      <td [style.display]="(currXnTypeID == 5 || currXnTypeID == 2 || currXnTypeID == 9 || currXnTypeID == 7 || currXnTypeID == 8) ? ' ' : 'none'" mat-cell *matCellDef="let element" style="width: 20px;"> <i style="color:#E1A730; margin: 5px;"
          class="fa fa-sticky-note" *ngIf="element.XnNotes" title="{{element.XnNotes ? element.XnNotes : '-'}}">{{element.XnNotes ? element.XnNotes : '-'}}</i>
      </td>
    </ng-container>

    <ng-container matColumnDef="Consignee">
      <th [style.display]="(currXnTypeID == 4 ) ? ' ' : 'none'" class="header header-Table"
       style="cursor: pointer; border-radius: 0px; margin: 0px !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Consignee</label>
      </th>
      <td [style.display]="(currXnTypeID == 4) ? ' ' : 'none'" mat-cell *matCellDef="let element">
           {{element.Name != '' ? element.Name : '-'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="Supplier">
      <th [style.display]="(currXnTypeID == 1 ) ? ' ' : 'none'" class="header header-Table"
       style="cursor: pointer; border-radius: 0px; margin: 0px !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>Supplier</label>
      </th>
      <td [style.display]="(currXnTypeID == 1) ? ' ' : 'none'" mat-cell *matCellDef="let element">
           {{element.Name != '' ? element.Name : '-'}}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="XnFile">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
        <label>File</label>
      </th>
      <td mat-cell *matCellDef="let element"> {{element.XnFile}} </td>
    </ng-container> -->

    <ng-container matColumnDef="Action">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>

      </th>
      <td mat-cell *matCellDef="let element; let i = index" style="text-align: left;">
        <div class="budge2 btn darkBlueButton padLeft5 hvrInfo btnBottom brdrRadius3" (click)="printTranjection(element.XnID, element.XnTypeID)" title="Print"
          style="padding: 5px 10px !important;display: inline-block;border-radius: 16px;text-align: center;margin-top: 5px; margin-left: 10px; font-size: 16px;"
          *ngIf="[1, 2, 4, 5, 7, 9, 10, 12, 13].includes(element.XnTypeID)">
          <i aria-hidden="true" class="zmdi zmdi-print"></i>
        </div>

        <div class="budge2 btn darkBlueButton padLeft5 hvrInfo btnBottom brdrRadius3" (click)="openInvoice(element.XnTypeID, element.XnID)" title="Create Invoice"
          style="padding: 5px 10px !important;display: inline-block;border-radius: 16px;text-align: center;margin-top: 5px; margin-left: 10px; font-size: 13px;"
          *ngIf="(element.Reference == '0' || element.Reference == '') && (element.XnTypeID == 4 || element.XnTypeID == 1)">
          <i aria-hidden="true" class="fa fa-file"></i>
        </div>

      </td>
    </ng-container>
    <!-- element.XnTypeID == 8 ||  -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
  </table>


  <!-- Angular 8 pagination -->
  <mat-paginator [pageSizeOptions]="[10,20,30,40,50]" showFirstLastButtons>
  </mat-paginator>
</div>

</div>

<div *ngIf="dataSource.data.length == 0">
  <div style="margin:15px 5px" class="no-record-badge">No records found.</div>
</div>
</div>